var map = {
	"./007-microphone-1.png": 8703,
	"./010-home.png": 7952,
	"./013-document-1.png": 1345,
	"./014-document.png": 3534,
	"./015-color-palette.png": 5943,
	"./017-video-camera.png": 3291,
	"./024-like.svg": 1311,
	"./1.svg": 1866,
	"./155-credit-card.svg": 6589,
	"./2.svg": 9977,
	"./3.svg": 2088,
	"./4.svg": 4919,
	"./New Customer.svg": 1559,
	"./NotOpen.svg": 2092,
	"./Opened.svg": 9042,
	"./Profit.svg": 2587,
	"./SalesRevenue.svg": 6229,
	"./Sent.svg": 3687,
	"./Slack.svg": 4959,
	"./address.svg": 7683,
	"./adidas.svg": 8509,
	"./adobe.svg": 6894,
	"./arrow-growth.svg": 9688,
	"./arrow-left.png": 4666,
	"./arrow-left.svg": 682,
	"./arrow-right.png": 4612,
	"./arrow-right.svg": 7969,
	"./bell.svg": 1478,
	"./book-open.svg": 5831,
	"./book.svg": 1986,
	"./briefcase.svg": 19,
	"./camera.svg": 2076,
	"./chat.svg": 5455,
	"./check-circle.svg": 2436,
	"./clipboard.svg": 3313,
	"./clock.svg": 8493,
	"./cloud.svg": 1248,
	"./columns.svg": 8642,
	"./documentation.svg": 7309,
	"./dollar-circle.svg": 92,
	"./envelope.svg": 4805,
	"./file.svg": 4671,
	"./flat.svg": 8908,
	"./google-customIcon.svg": 8363,
	"./google-plus.svg": 2421,
	"./headphone.svg": 1609,
	"./heart-fill.svg": 9359,
	"./home.svg": 1768,
	"./iconfinder_trello_2317760.svg": 1300,
	"./idea.svg": 5787,
	"./image.png": 8774,
	"./image.svg": 2576,
	"./label.png": 4307,
	"./layers.svg": 9487,
	"./left-bar.svg": 4302,
	"./left.svg": 3902,
	"./logo2.svg": 8502,
	"./logo3.svg": 5367,
	"./logo4.svg": 2968,
	"./logo5.svg": 5337,
	"./logo6.svg": 6042,
	"./logoIn.svg": 1825,
	"./message.svg": 7022,
	"./microsoft.svg": 4139,
	"./money-wave.svg": 3407,
	"./paint.svg": 9867,
	"./protection.svg": 4396,
	"./quote-left.png": 3719,
	"./quote-right.png": 8936,
	"./quote.png": 4873,
	"./repeat.svg": 7964,
	"./right.svg": 4045,
	"./setting.svg": 5467,
	"./shopping-cart.svg": 2552,
	"./speed-meter.svg": 5666,
	"./strategy.svg": 9882,
	"./theme.svg": 484,
	"./ticket.svg": 7185,
	"./user.svg": 1080,
	"./users-alt.svg": 8565,
	"./water-fall.svg": 7168,
	"./wordpress.svg": 634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6609;